import { defineMessages } from "react-intl";

export const messages = defineMessages({
    successLevel: {
        id: "IncidentLevel.success.level",
        defaultMessage: "Working",
        description: "Tag with level in top of unresolved incident card",
    },
    warningLevel: {
        id: "IncidentLevel.warning.level",
        defaultMessage: "Low impact",
        description: "Tag with level in top of unresolved incident card",
    },
    dangerLevel: {
        id: "IncidentLevel.danger.level",
        defaultMessage: "High impact",
        description: "Tag with level in top of unresolved incident card",
    },
    title: {
        id: "unresolvedIncidents.title",
        defaultMessage: "Unresolved Incidents",
        description: "Unresolved Incidents title",
    },
});
